import React from "react";
import Dict from 'dict-lib';
import {Button, ButtonGroup, ButtonToolbar, Col, Grid, Modal, Row} from 'react-bootstrap';
import ReactDOM from "react-dom";

import stylesScNavbar from '../../../dict-components/navbar/ScNavbar.module.css';
import {SCCombo} from "../../../dict-components/combo/SCCombo";
import {userService} from "../../../_redux/authentication/services/user.services";
import stylesSearchMenu from "../../../_css/dictionary/searchMenu.module.css";
import SCRadiobutton from "../../../dict-components/radiobutton/SCRadiobutton";
import {AdministrationUtilities} from "../../AdministrationHelper";


export class ExportPickle extends React.Component {
    constructor(props) {
        super(props);

        this.rootLanguages = Dict.getVarious('root_languages');

        this.state = {
            show: true,
            status: 'STOP',
            langIn: this.rootLanguages[0],
            langOut: this.rootLanguages[1],
            result: '',
            step: 1,
            indexing: 'waiting',
            resultStatus: ''
        };
    }

    _close() {
        if (!this.state.exportStarted) {
            this.setState({show: false}, () => {
                //this._stopImport();
                setTimeout(function () {
                    ReactDOM.unmountComponentAtNode(document.getElementById("dict-modal-container"));
                }, 200);
            });
        } else {
            alert('Prima di chiudere devi stoppare l\'importazione in corso');
        }
    }

    _handleRadioInLangChange(langInId) {
        const langIn = this.rootLanguages.find((item) => {
            return langInId === item.id;
        })

        this.setState({langIn});
    }

    _handleRadioLangOutChange(langOutId) {
        const langOut = this.rootLanguages.find((item) => {
            return langOutId === item.id;
        })

        this.setState({langOut})
    }

    _retrieveWords(index) {
        const service = '/concurrentServices/' + (this.props.type === 'complete' ? 'exportForDictionaryPickle/' + this.state.langIn.id + '/' + this.state.langOut.id + '/' + index + '/' : 'exportSimilarForDictionaryPickle/' + this.rootLanguages.findIndex((item) => {
            return (item.id === this.state.langIn.id);
        }) + '/' + index + '/-1/');

        Dict.call(service).then((result) => {
            if (result.index > 0 /*&& result.index < 4000 !result.msg.startsWith('["co')*/) {
                this.setState({resultStatus: result.index + '/' + result.totalCount + ") " + result.msg})
                if (this.state.status === 'STARTED')
                    this._retrieveWords(result.index);
            } else {
                this.setState({resultStatus: 'FINE', status: 'FINISHED'})
            }
        })
    }


    render() {
        var modalBody = <Modal.Body>'In attesa...'</Modal.Body>;
        const isComplete = this.props.type === 'complete';
        var status = this.state.status;
        var buttonName = 'Avvia';
        if (status === 'STARTED') {
            buttonName = 'Interrompi'
        }

        modalBody = <>
            <Modal.Body>
                <Row className={stylesScNavbar['pickle-row-options']}>
                    <SCRadiobutton key={"key-radio-languages-in"} bsStyle="primary"
                                   label={isComplete ? 'Lingua di partenza' : 'Colonna da estrarre'}
                                   additionalClass={stylesScNavbar['pickle-dict-align-language']}
                                   id={'dict-align-language-in'}
                                   items={this.rootLanguages.filter((langItem) => {
                                       return langItem[userService.isLogged() ? 'is_active' : 'is_frontend_active'] === true;
                                   }).map((item) => {
                                       return {label: item.label, code: item.id + ''};
                                   })}
                                   default={this.state.langIn.id + ''}
                                   callbackParent={(newState) => this._handleRadioInLangChange(parseInt(newState))}/>
                    {isComplete ? <SCRadiobutton key={"key-radio-languages-out"} bsStyle="primary"
                                                 label={'Lingua di arrivo'}
                                                 additionalClass={stylesScNavbar['pickle-dict-align-language']}
                                                 id={'dict-align-language-out'}
                                                 items={this.rootLanguages.filter((langItem) => {
                                                     return langItem[userService.isLogged() ? 'is_active' : 'is_frontend_active'] === true;
                                                 }).map((item) => {
                                                     return {label: item.label, code: item.id + ''};
                                                 })}
                                                 default={this.state.langOut.id + ''}
                                                 callbackParent={(newState) => this._handleRadioLangOutChange(parseInt(newState))}/> : ''}
                    <div className={stylesScNavbar['pickle-dict-align-start-div']}>
                        <Button onClick={() => {
                            if (status !== 'STARTED') {
                                this.setState({status: 'STARTED', resultStatus: 'AVVIATO'})
                                this._retrieveWords(0);
                            } else {
                                this.setState({status: 'STOP', resultStatus: 'STOPPATO'})
                            }
                        }}
                        >{buttonName}</Button>
                    </div>
                </Row>
                <Row className={stylesScNavbar['pickle-row-results']}>
                    <div className={stylesScNavbar['pickle-div-results']}>
                        {this.state.resultStatus}
                    </div>
                </Row>
            </Modal.Body>
            <Modal.Footer>
            </Modal.Footer>
        </>


        return <Modal id="pickle-modal" show={this.state.show}
                      dialogClassName={stylesScNavbar['pickle-dict-import-modal']}
                      restoreFocus onHide={() => this._close()}>
            <Modal.Header closeButton><h4
                className={'modal-title'}>{isComplete ? 'Crea Pickle' : 'Esporta colonna Pickle'}</h4></Modal.Header>
            {modalBody}
        </Modal>;
    }
}